import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ExtractStudyApp from './components/ExtractStudyApp';
import AuthPage from './pages/AuthPage';
import VocabularyBook from './pages/VocabularyBook';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<AuthPage mode="login" />} />
          <Route path="/signup" element={<AuthPage mode="signup" />} />
          <Route path="/vocabulary" element={<VocabularyBook />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<ExtractStudyApp />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
